import { render } from "./UpgradeAccountAlt.vue?vue&type=template&id=08dbc4a2"
import script from "./UpgradeAccountAlt.vue?vue&type=script&lang=js"
export * from "./UpgradeAccountAlt.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__